<template>
  <component
    :is="fill ? filledSymbolsMap[name] : symbolsMap[name]"
    :style="{ height: sizeValue, width: sizeValue }"
    :class="sizeClassValue"
    v-bind="attrs"
  ></component>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

import { Size } from '../gvIcon/types';
import { filledSymbolsMap, symbolsMap } from './constants';

export type GvIconProps = {
  name: string;
  fill?: boolean;
  size?: Size;
  ariaLabel?: string;
};

const props = withDefaults(defineProps<GvIconProps>(), {
  fill: false,
  size: 'md',
  ariaLabel: undefined,
});

const attrs = computed(() => {
  if (props.ariaLabel) {
    return { 'aria-label': props.ariaLabel };
  }
  // If no label is provided, it's safe to assume the icon is decorative.
  return { 'aria-hidden': true };
});

const sizeMap: Record<Size, string> = {
  '2xs': '12',
  xs: '16',
  sm: '20',
  md: '24',
  lg: '40',
  xl: '48',
  custom: '',
};

const sizeClass: Record<Size, string> = {
  '2xs': 'h-3 w-3',
  xs: 'h-4 w-4',
  sm: 'h-5 w-5',
  md: 'h-6 w-6',
  lg: 'h-10 w-10',
  xl: 'h-12 w-12',
  custom: '',
};

const sizeValue = computed(() => sizeMap[props.size]);
const sizeClassValue = computed(() => sizeClass[props.size]);
</script>
